<organism-modal
    [modalTitle]="
        TRANSLATION_DOC_CHECKLIST_DOC_CHECKLIST_GENERATE_TEMPLATE
            | translateTokenisedString
    "
>
    <form
        class="d-flex flex-column h-100 overflow-hidden"
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
    >
        <div
            class="form-action-buttons navbar justify-content-end flex-shrink-0"
        >
            <button
                class="btn btn-outline-primary ms-2"
                type="button"
                [disabled]="isGenerating$ | ngrxPush"
                (click)="onCancel()"
            >
                {{ TRANSLATION_CANCEL_BTN | translateTokenisedString }}
            </button>

            <atom-async-button
                [isLoading]="isGenerating$ | ngrxPush"
                btnClass="btn btn-primary ms-2"
                data-cy="btn-generate-doc-template"
                >{{ TRANSLATION_GENERATE_BTN | translateTokenisedString }}
            </atom-async-button>
        </div>
        <div class="form-container flex-grow-1 overflow-hidden">
            <atom-async-data
                [isLoading]="isGenerating$ | ngrxPush"
                [overlayContent]="true"
                [throbberContainerStyle]="false"
            >
                <form
                    class="form h-100 w-100 overflow-auto d-flex position-relative"
                    autocomplete="off"
                >
                    <div
                        ngbAccordion
                        #accordion
                        class="w-100 accordion form-accordion accordion-flush"
                        [destroyOnHide]="false"
                        [closeOthers]="true"
                    >
                        @for (
                            item of items;
                            track $index;
                            let i = $index;
                            let first = $first
                        ) {
                            <div
                                [ngbAccordionItem]="
                                    'document-generation-panel-' + i
                                "
                                [ngClass]="'bg-muted' + (first ? '' : ' mt-1')"
                                [collapsed]="!first"
                            >
                                <div ngbAccordionHeader>
                                    <button
                                        ngbAccordionButton
                                        class="form-section__header accordion-header accordion-button d-flex align-items-center bg-muted"
                                    >
                                        <h6 class="flex-grow-1">
                                            {{ item.description }}
                                        </h6>
                                    </button>
                                </div>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <clmi-generate-document-template-form
                                            [documentRequirementId]="
                                                item.documentRequirementId
                                            "
                                            [documentTypeCodes]="
                                                item.documentTypeCodes
                                            "
                                        ></clmi-generate-document-template-form>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </form>
            </atom-async-data>
        </div>
    </form>
</organism-modal>
